import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const usePreventBack = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Push a new entry into the history stack
    window.history.pushState(null, '', window.location.href);

    const handlePopState = (event) => {
      // Prevent the default back behavior
      window.history.pushState(null, '', window.location.href);
    };

    // Add event listener for popstate
    window.addEventListener('popstate', handlePopState);

    // Cleanup
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);
};

export default usePreventBack; 